import Axios from "../utils/axios";

const axios = new Axios();

export interface IFees {
  id?: string;
  legacyId?: string | number;
  limit: number;
  dues: number;
  fees: number;
  details: string;
  type: string;
  FyYear: number | string;
  assessmentfees: number;
}

export const getFees = async (): Promise<IFees[]> => {
  try {
    const response = await axios.Get('/fees');
    return response.data;
  } catch (error) {
    console.error('Error fetching Fees:', error);
    return [];
  }
};

export const getFeesByFilter = async (filter: any): Promise<IFees[]> => {
  try {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify(filter));
    const response = await axios.Get(`./fees?${params.toString()}`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching Fees:", error);
    return [];
  }
};

export const getFeesByFyYearAndType = async (fyYear: number | string, type: string): Promise<IFees[]> => {
  try {
    const params = new URLSearchParams();
    const filterData: any = {
      FyYear: { value: String(fyYear), comparisonType: 'EQUAL' },
      type: { value: type, comparisonType: 'EQUAL' }
    };
    params.append('filter', JSON.stringify(filterData));
    const response = await axios.Get(`./fees?${params.toString()}`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching Fees:", error);
    return [];
  }
};

export const addFees = async (fees: IFees): Promise<IFees> => {
  try {
    const response = await axios.Post('fees', fees);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateFees = async (fees: IFees): Promise<IFees> => {
  try {
    const response = await axios.Put('fees', fees);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteFees = async (feesId: string) => {
  try {
    await axios.Delete('fees', feesId);
    return true;
  } catch (error) {
    throw error;
  }
};

